import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.string.trim-end.js";
import React from 'react';
import { map, mapWithDefault, withDefault } from '@code-hike/utils';
import { setCDN, getHighlighter } from 'shiki';
import { diffLines } from 'diff';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
}

function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
}

function mapFocusToLineNumbers(focus, lines) {
  if (!focus) {
    // focus all lines
    return mergeToObject(__spread(lines.keys()).map(function (lineIndex) {
      var _a;

      return _a = {}, _a[lineIndex + 1] = true, _a;
    }));
  } else {
    return mergeToObject(focus.split(/,(?![^\[]*\])/g).map(parsePartToObject));
  }
}

function mergeToObject(entries) {
  return entries.reduce(function (acc, obj) {
    return Object.assign(acc, obj);
  }, {});
}

function hasColumns(part) {
  return !!part.match(/(\d+)\[(.+)\]/);
}

function parsePartToObject(part) {
  var _a; // a part could be
  // - a line number: "2"
  // - a line range: "5:9"
  // - a line number with a column selector: "2[1,3:5,9]"


  var columnsMatch = part.match(/(\d+)\[(.+)\]/);

  if (columnsMatch) {
    var _b = __read(columnsMatch, 3),
        line = _b[1],
        columns = _b[2];

    var columnsList = columns.split(",").map(parseExtremes);
    var lineNumber = Number(line);
    return _a = {}, _a[lineNumber] = columnsList, _a;
  } else {
    return mergeToObject(expandString(part).map(function (lineNumber) {
      var _a;

      return _a = {}, _a[lineNumber] = true, _a;
    }));
  }
}

function parseExtremes(part) {
  // Transforms something like
  // - "1:3" to {start:1, end: 3}
  // - "4" to {start:4, end:4}
  var _a = __read(part.split(":"), 2),
      start = _a[0],
      end = _a[1];

  if (!isNaturalNumber(start)) {
    throw new FocusNumberError(start);
  }

  var startNumber = Number(start);

  if (startNumber < 1) {
    throw new LineOrColumnNumberError();
  }

  if (!end) {
    return {
      start: startNumber,
      end: startNumber
    };
  } else {
    if (!isNaturalNumber(end)) {
      throw new FocusNumberError(end);
    }

    return {
      start: startNumber,
      end: +end
    };
  }
}

function getFocusIndexes(focus, lines) {
  if (!focus) {
    return __spread(lines.keys());
  } else {
    var parsed = parseFocus(focus);
    var focusedIndexes = Object.keys(parsed).map(function (i) {
      return parseInt(i, 10);
    });
    return focusedIndexes;
  }
}

function parseFocus(focus) {
  if (!focus) {
    throw new Error("Focus cannot be empty");
  }

  try {
    var parts = focus.split(/,(?![^\[]*\])/g).map(parsePart);
    return fromEntries(parts.flat());
  } catch (error) {
    // TODO enhance error
    throw error;
  }
}

function parsePart(part) {
  // a part could be
  // - a line number: "2"
  // - a line range: "5:9"
  // - a line number with a column selector: "2[1,3:5,9]"
  var columnsMatch = part.match(/(\d+)\[(.+)\]/);

  if (columnsMatch) {
    var _a = __read(columnsMatch, 3),
        line = _a[1],
        columns = _a[2];

    var columnsList = columns.split(",").map(expandString);
    var lineIndex = Number(line) - 1;
    var columnIndexes = columnsList.flat().map(function (c) {
      return c - 1;
    });
    return [[lineIndex, columnIndexes]];
  } else {
    return expandString(part).map(function (lineNumber) {
      return [lineNumber - 1, true];
    });
  }
}

function expandString(part) {
  // Transforms something like
  // - "1:3" to [1,2,3]
  // - "4" to [4]
  var _a = __read(part.split(":"), 2),
      start = _a[0],
      end = _a[1];

  if (!isNaturalNumber(start)) {
    throw new FocusNumberError(start);
  }

  var startNumber = Number(start);

  if (startNumber < 1) {
    throw new LineOrColumnNumberError();
  }

  if (!end) {
    return [startNumber];
  } else {
    if (!isNaturalNumber(end)) {
      throw new FocusNumberError(end);
    }

    var list = [];

    for (var i = startNumber; i <= +end; i++) {
      list.push(i);
    }

    return list;
  }
}

function isNaturalNumber(n) {
  n = n.toString(); // force the value in case it is not

  var n1 = Math.abs(n),
      n2 = parseInt(n, 10);
  return !isNaN(n1) && n2 === n1 && n1.toString() === n;
}

var LineOrColumnNumberError = function (_super) {
  __extends(LineOrColumnNumberError, _super);

  function LineOrColumnNumberError() {
    var _newTarget = this.constructor;

    var _this = _super.call(this, "Invalid line or column number in focus string") || this;

    Object.setPrototypeOf(_this, _newTarget.prototype);
    return _this;
  }

  return LineOrColumnNumberError;
}(Error);

var FocusNumberError = function (_super) {
  __extends(FocusNumberError, _super);

  function FocusNumberError(number) {
    var _newTarget = this.constructor;

    var _this = _super.call(this, "Invalid number \"" + number + "\" in focus string") || this;

    _this.number = number;
    Object.setPrototypeOf(_this, _newTarget.prototype);
    return _this;
  }

  return FocusNumberError;
}(Error);

function fromEntries(pairs) {
  var result = {};
  var index = -1,
      length = pairs == null ? 0 : pairs.length;

  while (++index < length) {
    var pair = pairs[index];
    result[pair[0]] = pair[1];
  }

  return result;
}

var useLayoutEffect = typeof window !== "undefined" ? React.useLayoutEffect : React.useEffect;
var DEFAULT_WIDTH = 200; // type DimensionsResult = {
//   width: number
//   height: number
//   lineWidths: { prev: number; next: number }
//   lineHeight: number
//   colWidth: number
// }

function useDimensions(code, focus, minColumns, deps) {
  var _a = __read(React.useState(null), 2),
      dimensions = _a[0],
      setDimensions = _a[1];

  var windowWidth = useWindowWidth();
  var prevLongestLine = getLongestLine(code.prev, focus.prev);
  var nextLongestLine = getLongestLine(code.next, focus.next);
  var prevLineRef = React.useRef(null);
  var nextLineRef = React.useRef(null);
  var element = React.createElement(React.Fragment, null, React.createElement("div", {
    ref: prevLineRef
  }, React.createElement("div", {
    style: {
      display: "inline-block"
    }
  }, React.createElement("span", null, prevLongestLine))), React.createElement("div", {
    ref: nextLineRef
  }, React.createElement("div", {
    style: {
      display: "inline-block"
    }
  }, React.createElement("span", null, nextLongestLine))));

  var allDeps = __spread(deps, [windowWidth, prevLongestLine, nextLongestLine, minColumns]);

  useLayoutEffect(function () {
    var _a, _b, _c, _d, _e, _f, _g, _h;

    if (prevLineRef.current) {
      var pll = prevLineRef.current;
      var nll = nextLineRef.current;
      var codeElement = (pll === null || pll === void 0 ? void 0 : pll.parentElement) || (nll === null || nll === void 0 ? void 0 : nll.parentElement); // TODO is it clientWidth or clientRect?

      var plw = (_a = pll === null || pll === void 0 ? void 0 : pll.firstElementChild) === null || _a === void 0 ? void 0 : _a.clientWidth;
      var nlw = (_b = nll === null || nll === void 0 ? void 0 : nll.firstElementChild) === null || _b === void 0 ? void 0 : _b.clientWidth;
      var plh = (_d = (_c = pll === null || pll === void 0 ? void 0 : pll.firstElementChild) === null || _c === void 0 ? void 0 : _c.clientHeight) !== null && _d !== void 0 ? _d : 20;
      var nlh = (_f = (_e = nll === null || nll === void 0 ? void 0 : nll.firstElementChild) === null || _e === void 0 ? void 0 : _e.clientHeight) !== null && _f !== void 0 ? _f : 20;
      var colWidth = pll ? plw / (((_g = pll.textContent) === null || _g === void 0 ? void 0 : _g.length) || 1) : nlw / (((_h = nll.textContent) === null || _h === void 0 ? void 0 : _h.length) || 1);
      var d = {
        containerWidth: getWidthWithoutPadding(codeElement.parentElement),
        containerHeight: getHeightWithoutPadding(codeElement.parentElement),
        lineWidths: [plw || nlw || DEFAULT_WIDTH, nlw || plw || DEFAULT_WIDTH],
        lineWidth: [Math.max(plw || nlw || DEFAULT_WIDTH, colWidth * minColumns), Math.max(nlw || plw || DEFAULT_WIDTH, colWidth * minColumns)],
        lineHeight: Math.max(plh, nlh),
        colWidth: colWidth,
        deps: allDeps
      };
      setDimensions(d);
    }
  }, [allDeps]);

  if (!dimensions || depsChanged$1(dimensions.deps, allDeps)) {
    return {
      element: element,
      dimensions: null
    };
  } else {
    return {
      element: element,
      dimensions: dimensions
    };
  }
}

var newlineRe$1 = /\r\n|\r|\n/;

function getLongestLine(code, focus) {
  var lines = code ? code.split(newlineRe$1) : [""];
  var focusIndexes = getFocusIndexes(focus, lines);
  var longestLine = "";
  lines.forEach(function (line, index) {
    if (focusIndexes.includes(index) && line.length > longestLine.length) {
      longestLine = line;
    }
  });
  return longestLine;
}

function getWidthWithoutPadding(element) {
  var computedStyle = getComputedStyle(element);
  return element.clientWidth - parseFloat(computedStyle.paddingLeft) - parseFloat(computedStyle.paddingRight);
}

function getHeightWithoutPadding(element) {
  var computedStyle = getComputedStyle(element);
  return parseFloat(computedStyle.height) - parseFloat(computedStyle.paddingTop) - parseFloat(computedStyle.paddingBottom);
}

function depsChanged$1(oldDeps, newDeps) {
  for (var i = 0; i < oldDeps.length; i++) {
    if (oldDeps[i] !== newDeps[i]) return true;
  }

  return false;
}

function useWindowWidth() {
  var _a = __read(React.useState(undefined), 2),
      width = _a[0],
      setWidth = _a[1];

  React.useEffect(function () {
    function handleResize() {
      setWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  return width;
}

var $schema = "vscode://schemas/color-theme";
var name = "dark-plus";
var tokenColors = [{
  settings: {
    foreground: "#D4D4D4"
  }
}, {
  scope: ["meta.embedded", "source.groovy.embedded"],
  settings: {
    foreground: "#D4D4D4"
  }
}, {
  scope: "emphasis",
  settings: {
    fontStyle: "italic"
  }
}, {
  scope: "strong",
  settings: {
    fontStyle: "bold"
  }
}, {
  scope: "header",
  settings: {
    foreground: "#000080"
  }
}, {
  scope: "comment",
  settings: {
    foreground: "#6A9955"
  }
}, {
  scope: "constant.language",
  settings: {
    foreground: "#569cd6"
  }
}, {
  scope: ["constant.numeric", "variable.other.enummember", "keyword.operator.plus.exponent", "keyword.operator.minus.exponent"],
  settings: {
    foreground: "#b5cea8"
  }
}, {
  scope: "constant.regexp",
  settings: {
    foreground: "#646695"
  }
}, {
  scope: "entity.name.tag",
  settings: {
    foreground: "#569cd6"
  }
}, {
  scope: "entity.name.tag.css",
  settings: {
    foreground: "#d7ba7d"
  }
}, {
  scope: "entity.other.attribute-name",
  settings: {
    foreground: "#9cdcfe"
  }
}, {
  scope: ["entity.other.attribute-name.class.css", "entity.other.attribute-name.class.mixin.css", "entity.other.attribute-name.id.css", "entity.other.attribute-name.parent-selector.css", "entity.other.attribute-name.pseudo-class.css", "entity.other.attribute-name.pseudo-element.css", "source.css.less entity.other.attribute-name.id", "entity.other.attribute-name.scss"],
  settings: {
    foreground: "#d7ba7d"
  }
}, {
  scope: "invalid",
  settings: {
    foreground: "#f44747"
  }
}, {
  scope: "markup.underline",
  settings: {
    fontStyle: "underline"
  }
}, {
  scope: "markup.bold",
  settings: {
    fontStyle: "bold",
    foreground: "#569cd6"
  }
}, {
  scope: "markup.heading",
  settings: {
    fontStyle: "bold",
    foreground: "#569cd6"
  }
}, {
  scope: "markup.italic",
  settings: {
    fontStyle: "italic"
  }
}, {
  scope: "markup.inserted",
  settings: {
    foreground: "#b5cea8"
  }
}, {
  scope: "markup.deleted",
  settings: {
    foreground: "#ce9178"
  }
}, {
  scope: "markup.changed",
  settings: {
    foreground: "#569cd6"
  }
}, {
  scope: "punctuation.definition.quote.begin.markdown",
  settings: {
    foreground: "#6A9955"
  }
}, {
  scope: "punctuation.definition.list.begin.markdown",
  settings: {
    foreground: "#6796e6"
  }
}, {
  scope: "markup.inline.raw",
  settings: {
    foreground: "#ce9178"
  }
}, {
  name: "brackets of XML/HTML tags",
  scope: "punctuation.definition.tag",
  settings: {
    foreground: "#808080"
  }
}, {
  scope: ["meta.preprocessor", "entity.name.function.preprocessor"],
  settings: {
    foreground: "#569cd6"
  }
}, {
  scope: "meta.preprocessor.string",
  settings: {
    foreground: "#ce9178"
  }
}, {
  scope: "meta.preprocessor.numeric",
  settings: {
    foreground: "#b5cea8"
  }
}, {
  scope: "meta.structure.dictionary.key.python",
  settings: {
    foreground: "#9cdcfe"
  }
}, {
  scope: "meta.diff.header",
  settings: {
    foreground: "#569cd6"
  }
}, {
  scope: "storage",
  settings: {
    foreground: "#569cd6"
  }
}, {
  scope: "storage.type",
  settings: {
    foreground: "#569cd6"
  }
}, {
  scope: ["storage.modifier", "keyword.operator.noexcept"],
  settings: {
    foreground: "#569cd6"
  }
}, {
  scope: ["string", "meta.embedded.assembly"],
  settings: {
    foreground: "#ce9178"
  }
}, {
  scope: "string.tag",
  settings: {
    foreground: "#ce9178"
  }
}, {
  scope: "string.value",
  settings: {
    foreground: "#ce9178"
  }
}, {
  scope: "string.regexp",
  settings: {
    foreground: "#d16969"
  }
}, {
  name: "String interpolation",
  scope: ["punctuation.definition.template-expression.begin", "punctuation.definition.template-expression.end", "punctuation.section.embedded"],
  settings: {
    foreground: "#569cd6"
  }
}, {
  name: "Reset JavaScript string interpolation expression",
  scope: ["meta.template.expression"],
  settings: {
    foreground: "#d4d4d4"
  }
}, {
  scope: ["support.type.vendored.property-name", "support.type.property-name", "variable.css", "variable.scss", "variable.other.less", "source.coffee.embedded"],
  settings: {
    foreground: "#9cdcfe"
  }
}, {
  scope: "keyword",
  settings: {
    foreground: "#569cd6"
  }
}, {
  scope: "keyword.control",
  settings: {
    foreground: "#569cd6"
  }
}, {
  scope: "keyword.operator",
  settings: {
    foreground: "#d4d4d4"
  }
}, {
  scope: ["keyword.operator.new", "keyword.operator.expression", "keyword.operator.cast", "keyword.operator.sizeof", "keyword.operator.alignof", "keyword.operator.typeid", "keyword.operator.alignas", "keyword.operator.instanceof", "keyword.operator.logical.python", "keyword.operator.wordlike"],
  settings: {
    foreground: "#569cd6"
  }
}, {
  scope: "keyword.other.unit",
  settings: {
    foreground: "#b5cea8"
  }
}, {
  scope: ["punctuation.section.embedded.begin.php", "punctuation.section.embedded.end.php"],
  settings: {
    foreground: "#569cd6"
  }
}, {
  scope: "support.function.git-rebase",
  settings: {
    foreground: "#9cdcfe"
  }
}, {
  scope: "constant.sha.git-rebase",
  settings: {
    foreground: "#b5cea8"
  }
}, {
  name: "coloring of the Java import and package identifiers",
  scope: ["storage.modifier.import.java", "variable.language.wildcard.java", "storage.modifier.package.java"],
  settings: {
    foreground: "#d4d4d4"
  }
}, {
  name: "this.self",
  scope: "variable.language",
  settings: {
    foreground: "#569cd6"
  }
}, {
  name: "Function declarations",
  scope: ["entity.name.function", "support.function", "support.constant.handlebars", "source.powershell variable.other.member", "entity.name.operator.custom-literal"],
  settings: {
    foreground: "#DCDCAA"
  }
}, {
  name: "Types declaration and references",
  scope: ["meta.return-type", "support.class", "support.type", "entity.name.type", "entity.name.namespace", "entity.other.attribute", "entity.name.scope-resolution", "entity.name.class", "storage.type.numeric.go", "storage.type.byte.go", "storage.type.boolean.go", "storage.type.string.go", "storage.type.uintptr.go", "storage.type.error.go", "storage.type.rune.go", "storage.type.cs", "storage.type.generic.cs", "storage.type.modifier.cs", "storage.type.variable.cs", "storage.type.annotation.java", "storage.type.generic.java", "storage.type.java", "storage.type.object.array.java", "storage.type.primitive.array.java", "storage.type.primitive.java", "storage.type.token.java", "storage.type.groovy", "storage.type.annotation.groovy", "storage.type.parameters.groovy", "storage.type.generic.groovy", "storage.type.object.array.groovy", "storage.type.primitive.array.groovy", "storage.type.primitive.groovy"],
  settings: {
    foreground: "#4EC9B0"
  }
}, {
  name: "Types declaration and references, TS grammar specific",
  scope: ["meta.type.cast.expr", "meta.type.new.expr", "support.constant.math", "support.constant.dom", "support.constant.json", "entity.other.inherited-class"],
  settings: {
    foreground: "#4EC9B0"
  }
}, {
  name: "Control flow / Special keywords",
  scope: ["keyword.control", "source.cpp keyword.operator.new", "keyword.operator.delete", "keyword.other.using", "keyword.other.operator", "entity.name.operator"],
  settings: {
    foreground: "#C586C0"
  }
}, {
  name: "Variable and parameter name",
  scope: ["variable", "meta.definition.variable.name", "support.variable", "entity.name.variable", "constant.other.placeholder"],
  settings: {
    foreground: "#9CDCFE"
  }
}, {
  name: "Constants and enums",
  scope: ["variable.other.constant", "variable.other.enummember"],
  settings: {
    foreground: "#4FC1FF"
  }
}, {
  name: "Object keys, TS grammar specific",
  scope: ["meta.object-literal.key"],
  settings: {
    foreground: "#9CDCFE"
  }
}, {
  name: "CSS property value",
  scope: ["support.constant.property-value", "support.constant.font-name", "support.constant.media-type", "support.constant.media", "constant.other.color.rgb-value", "constant.other.rgb-value", "support.constant.color"],
  settings: {
    foreground: "#CE9178"
  }
}, {
  name: "Regular expression groups",
  scope: ["punctuation.definition.group.regexp", "punctuation.definition.group.assertion.regexp", "punctuation.definition.character-class.regexp", "punctuation.character.set.begin.regexp", "punctuation.character.set.end.regexp", "keyword.operator.negation.regexp", "support.other.parenthesis.regexp"],
  settings: {
    foreground: "#CE9178"
  }
}, {
  scope: ["constant.character.character-class.regexp", "constant.other.character-class.set.regexp", "constant.other.character-class.regexp", "constant.character.set.regexp"],
  settings: {
    foreground: "#d16969"
  }
}, {
  scope: ["keyword.operator.or.regexp", "keyword.control.anchor.regexp"],
  settings: {
    foreground: "#DCDCAA"
  }
}, {
  scope: "keyword.operator.quantifier.regexp",
  settings: {
    foreground: "#d7ba7d"
  }
}, {
  scope: "constant.character",
  settings: {
    foreground: "#569cd6"
  }
}, {
  scope: "constant.character.escape",
  settings: {
    foreground: "#d7ba7d"
  }
}, {
  scope: "entity.name.label",
  settings: {
    foreground: "#C8C8C8"
  }
}];
var semanticTokenColors = {
  newOperator: "#C586C0",
  stringLiteral: "#ce9178",
  customLiteral: "#DCDCAA",
  numberLiteral: "#b5cea8"
};
var colors = {
  "editor.background": "#1E1E1E",
  "editor.foreground": "#D4D4D4",
  "editor.inactiveSelectionBackground": "#3A3D41",
  "editorIndentGuide.background": "#404040",
  "editorIndentGuide.activeBackground": "#707070",
  "editor.selectionHighlightBackground": "#ADD6FF26",
  "list.dropBackground": "#383B3D",
  "activityBarBadge.background": "#007ACC",
  "sideBarTitle.foreground": "#BBBBBB",
  "input.placeholderForeground": "#A6A6A6",
  "menu.background": "#252526",
  "menu.foreground": "#CCCCCC",
  "statusBarItem.remoteForeground": "#FFF",
  "statusBarItem.remoteBackground": "#16825D",
  "ports.iconRunningProcessForeground": "#369432",
  "sideBarSectionHeader.background": "#0000",
  "sideBarSectionHeader.border": "#ccc3",
  "tab.lastPinnedBorder": "#ccc3",
  "list.activeSelectionIconForeground": "#FFF"
};
var DEFAULT_THEME = {
  $schema: $schema,
  name: name,
  tokenColors: tokenColors,
  semanticTokenColors: semanticTokenColors,
  colors: colors
};

function useAsyncMemo(_a, deps) {
  var isReady = _a.isReady,
      load = _a.load,
      run = _a.run,
      placeholder = _a.placeholder;

  var _b = __read(React.useState({
    result: null,
    deps: [],
    version: 0
  }), 2),
      _c = _b[0],
      lastLoadedResult = _c.result,
      lastLoadedDeps = _c.deps,
      version = _c.version,
      setState = _b[1];

  React.useEffect(function () {
    if (!isReady) {
      load().then(function () {
        setState(function (_a) {
          var version = _a.version;
          return {
            result: run(),
            deps: deps,
            version: version + 1
          };
        });
      });
    }
  }, deps);
  return React.useMemo(function () {
    if (depsChanged(deps, lastLoadedDeps)) {
      return isReady ? run() : placeholder();
    } else {
      return lastLoadedResult;
    }
  }, __spread([version], deps));
}

function depsChanged(oldDeps, newDeps) {
  if (oldDeps === newDeps) return false;
  if (!oldDeps || !newDeps) return true;
  return oldDeps === null || oldDeps === void 0 ? void 0 : oldDeps.some(function (dep, index) {
    return newDeps[index] !== dep;
  });
}
/**
 * From https://github.com/shikijs/shiki/blob/HEAD/packages/shiki/src/loader.ts
 */


var VSCODE_FALLBACK_EDITOR_FG = {
  light: "#333333",
  dark: "#bbbbbb"
};
var VSCODE_FALLBACK_EDITOR_BG = {
  light: "#fffffe",
  dark: "#1e1e1e"
};

function getThemeDefaultColors(theme) {
  var _a, _b, _c, _d, _e, _f;

  var fg, bg;
  /**
   * First try:
   * Theme might contain a global `tokenColor` without `name` or `scope`
   * Used as default value for foreground/background
   */

  var settings = theme.settings ? theme.settings : theme.tokenColors;
  var globalSetting = settings ? settings.find(function (s) {
    return !s.name && !s.scope;
  }) : undefined;

  if ((_a = globalSetting === null || globalSetting === void 0 ? void 0 : globalSetting.settings) === null || _a === void 0 ? void 0 : _a.foreground) {
    fg = globalSetting.settings.foreground;
  }

  if ((_b = globalSetting === null || globalSetting === void 0 ? void 0 : globalSetting.settings) === null || _b === void 0 ? void 0 : _b.background) {
    bg = globalSetting.settings.background;
  }
  /**
   * Second try:
   * If there's no global `tokenColor` without `name` or `scope`
   * Use `editor.foreground` and `editor.background`
   */


  if (!fg && ((_d = (_c = theme) === null || _c === void 0 ? void 0 : _c.colors) === null || _d === void 0 ? void 0 : _d["editor.foreground"])) {
    fg = theme.colors["editor.foreground"];
  }

  if (!bg && ((_f = (_e = theme) === null || _e === void 0 ? void 0 : _e.colors) === null || _f === void 0 ? void 0 : _f["editor.background"])) {
    bg = theme.colors["editor.background"];
  }
  /**
   * Last try:
   * If there's no fg/bg color specified in theme, use default
   */


  if (!fg) {
    fg = theme.type === "light" ? VSCODE_FALLBACK_EDITOR_FG.light : VSCODE_FALLBACK_EDITOR_FG.dark;
  }

  if (!bg) {
    bg = theme.type === "light" ? VSCODE_FALLBACK_EDITOR_BG.light : VSCODE_FALLBACK_EDITOR_BG.dark;
  }

  return {
    fg: fg,
    bg: bg
  };
}

var _a;

var highlighterPromise = null;
var highlighter = null;

function isHighlighterReady(lang, theme) {
  return highlighter != null && !missingTheme(highlighter, theme) && !missingLang(highlighter, lang);
}

function loadHighlighter(lang, theme) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (highlighterPromise === null) {
            setCDN("https://unpkg.com/shiki/");
            highlighterPromise = getHighlighter({
              theme: theme,
              langs: [lang]
            });
          }

          if (!(highlighter === null)) return [3
          /*break*/
          , 2];
          return [4
          /*yield*/
          , highlighterPromise];

        case 1:
          highlighter = _a.sent();
          _a.label = 2;

        case 2:
          if (!missingTheme(highlighter, theme)) return [3
          /*break*/
          , 4];
          return [4
          /*yield*/
          , highlighter.loadTheme(theme)];

        case 3:
          _a.sent();

          _a.label = 4;

        case 4:
          if (!missingLang(highlighter, lang)) return [3
          /*break*/
          , 6];
          return [4
          /*yield*/
          , highlighter.loadLanguage(lang)];

        case 5:
          _a.sent();

          _a.label = 6;

        case 6:
          return [2
          /*return*/
          ];
      }
    });
  });
}

function highlightOrPlaceholder(code, lang, theme) {
  if (isHighlighterReady(lang, theme)) {
    return getCodeLines(highlighter, code, lang, theme);
  } else {
    return tokenizePlaceholder(code);
  }
}

function getCodeLines(highlighter, code, lang, theme) {
  var lines = highlighter.codeToThemedTokens(code, lang, theme.name, {
    includeExplanation: false
  });
  return lines.map(function (line) {
    return line.map(function (token) {
      return [token.content, {
        style: getStyle(token)
      }];
    });
  });
}

function missingTheme(highlighter, theme) {
  return !highlighter.getLoadedThemes().some(function (t) {
    return t === theme.name;
  });
}

function missingLang(highlighter, lang) {
  return !highlighter.getLoadedLanguages().some(function (l) {
    return l === lang;
  });
}

var FONT_STYLE_TO_CSS = (_a = {}, _a[-1
/* NotSet */
] = {}, _a[0
/* None */
] = {}, _a[1
/* Italic */
] = {
  fontStyle: "italic"
}, _a[2
/* Bold */
] = {
  fontWeight: "bold"
}, _a[4
/* Underline */
] = {
  textDecoration: "underline"
}, _a);

function getStyle(token) {
  var fontStyle = token.fontStyle ? FONT_STYLE_TO_CSS[token.fontStyle] : {};
  return _assign({
    color: token.color
  }, fontStyle);
}

var newlineRe = /\r\n|\r|\n/;

function tokenizePlaceholder(code) {
  var lines = code.split(newlineRe);
  return lines.map(function (line) {
    return [[line, {}]];
  });
}

function mergeLines(code, lines) {
  var enterIndex = 0;
  var exitIndex = 0;
  var indexes = diff(code);
  var newLines = indexes.map(function (index) {
    if (index.next === undefined) {
      return _assign(_assign({}, lines.prev[index.prev]), {
        lineNumber: {
          prev: index.prev + 1
        },
        move: "exit",
        enterIndex: null,
        exitIndex: exitIndex++
      });
    }

    if (index.prev === undefined) {
      return _assign(_assign({}, lines.next[index.next]), {
        lineNumber: {
          next: index.next + 1
        },
        move: "enter",
        enterIndex: enterIndex++,
        exitIndex: null
      });
    }

    return _assign(_assign({}, lines.prev[index.prev]), {
      lineNumber: {
        prev: index.prev + 1,
        next: index.next + 1
      },
      move: "stay",
      enterIndex: null,
      exitIndex: null
    });
  });
  return {
    lines: newLines,
    enterCount: enterIndex,
    exitCount: exitIndex
  };
}
/**
 * Returns a list of pairs of line indexes:
 *
 * For example if lines 2 and 3 were removed
 * and two lines where added at the end:
 *  0 0
 *  1 -
 *  2 -
 *  3 1
 *  - 2
 *  - 3
 */


function diff(code) {
  var changes = diffLines(code.prev, code.next);
  var indexes = [];
  var prevIndex = 0;
  var nextIndex = 0;
  changes.forEach(function (change) {
    if (change.added) {
      for (var i = 0; i < change.count; i++) {
        indexes.push({
          next: nextIndex++
        });
      }
    } else if (change.removed) {
      for (var i = 0; i < change.count; i++) {
        indexes.push({
          prev: prevIndex++
        });
      }
    } else {
      for (var i = 0; i < change.count; i++) {
        indexes.push({
          prev: prevIndex++,
          next: nextIndex++
        });
      }
    }
  });
  return indexes;
}

function splitByFocus(mergedCode, focus, annotations) {
  var lines = mergedCode.lines,
      mergedCodeRest = __rest(mergedCode, ["lines"]);

  var focusByLineNumber = map(focus, function (focus) {
    return mapFocusToLineNumbers(focus, lines);
  });
  var splittedLines = lines.map(function (line) {
    var tokens = line.tokens,
        rest = __rest(line, ["tokens"]);

    var lineFocus = {
      prev: line.lineNumber.prev ? focusByLineNumber.prev[line.lineNumber.prev] : false,
      next: line.lineNumber.next ? focusByLineNumber.next[line.lineNumber.next] : false
    };
    var lineAnnotations = {
      prev: line.lineNumber.prev ? annotations.prev[line.lineNumber.prev] || [] : [],
      next: line.lineNumber.next ? annotations.next[line.lineNumber.next] || [] : []
    };
    return _assign({
      focused: map(lineFocus, function (focus) {
        return !!focus;
      }),
      groups: getTokenGroups(tokens, lineFocus, lineAnnotations)
    }, rest);
  });
  var focusedLineNumbers = map(focusByLineNumber, function (focusByLineNumber) {
    return Object.keys(focusByLineNumber).map(function (k) {
      return Number(k);
    });
  });
  var firstFocusedLineNumber = map(focusedLineNumbers, function (focusedLineNumbers) {
    return Math.min.apply(Math, __spread(focusedLineNumbers));
  });
  var lastFocusedLineNumber = map(focusedLineNumbers, function (focusedLineNumbers) {
    return Math.max.apply(Math, __spread(focusedLineNumbers));
  });
  return _assign({
    lines: splittedLines,
    firstFocusedLineNumber: firstFocusedLineNumber,
    lastFocusedLineNumber: lastFocusedLineNumber
  }, mergedCodeRest);
}
/**
 * Get the least amount of groups where no consecutive groups have
 * the same combination of prevFocus, nextFocus, prevAnnotation, nextAnnotation.
 */


function getTokenGroups(tokens, focus, annotations) {
  var focusExtremes = map(focus, function (focus) {
    return Array.isArray(focus) ? focus : [];
  });
  var annotationExtremes = map(annotations, function (annotations) {
    return annotations.map(function (_a) {
      var columnNumbers = _a.columnNumbers;
      return columnNumbers;
    });
  });

  var allExtremes = __spread(focusExtremes.prev, focusExtremes.next, annotationExtremes.prev, annotationExtremes.next);

  var splittedTokens = splitTokens(tokens, allExtremes);
  var startIndex = 0;
  var currentGroup = null;
  var groups = [];
  splittedTokens.forEach(function (token) {
    var newPrevFocus = isIn(startIndex, focus.prev);
    var newNextFocus = isIn(startIndex, focus.next);
    var newPrevAnnotation = getAnnotation(startIndex, annotations.prev);
    var newNextAnnotation = getAnnotation(startIndex, annotations.next);

    if (!currentGroup || currentGroup.focused.prev !== newPrevFocus || currentGroup.focused.next !== newNextFocus || currentGroup.annotation.prev !== newPrevAnnotation || currentGroup.annotation.next !== newNextAnnotation) {
      currentGroup = {
        focused: {
          prev: newPrevFocus,
          next: newNextFocus
        },
        tokens: [],
        annotation: {
          prev: newPrevAnnotation,
          next: newNextAnnotation
        }
      };
      groups.push(currentGroup);
    }

    currentGroup === null || currentGroup === void 0 ? void 0 : currentGroup.tokens.push(token);
    startIndex += token.content.length;
  });
  return groups.map(function (group) {
    return {
      focused: group.focused,
      tokens: group.tokens,
      element: getGroupElement(group)
    };
  });
}

function getGroupElement(group) {
  return React.createElement(React.Fragment, null, group.tokens.map(function (_a, i) {
    var content = _a.content,
        props = _a.props;
    return React.createElement("span", _assign({}, props, {
      key: i + 1
    }), content);
  }));
}
/**
 * Split a list of tokens into a more fine-graned list of tokens
 *
 * tokens: [abc][defg]
 * extremes: [1:2,2:5]
 * result tokens: [ab][c][de][fg]
 *
 */


function splitTokens(tokens, extremes) {
  var splitIndexes = __spread(extremes.map(function (e) {
    return e.start - 1;
  }), extremes.map(function (e) {
    return e.end;
  }));

  var oldTokens = tokens;
  splitIndexes.forEach(function (splitIndex) {
    var newTokens = [];
    var i = 0;
    oldTokens.forEach(function (token) {
      var startIndex = i;
      var endIndex = i + token.content.length;
      var shouldSplit = startIndex < splitIndex && splitIndex < endIndex;

      if (shouldSplit) {
        var sliceIndex = splitIndex - startIndex;
        var content0 = token.content.slice(0, sliceIndex);
        var content1 = token.content.slice(sliceIndex);
        newTokens.push(_assign(_assign({}, token), {
          content: content0
        }));
        newTokens.push(_assign(_assign({}, token), {
          content: content1
        }));
      } else {
        newTokens.push(token);
      }

      i = endIndex;
    });
    oldTokens = newTokens;
  });
  return oldTokens;
}

function isIn(index, intervals) {
  if (!Array.isArray(intervals)) {
    return intervals;
  }

  return intervals.some(function (_a) {
    var start = _a.start,
        end = _a.end;
    return start - 1 <= index && index < end;
  });
}

function getAnnotation(index, annotations) {
  return annotations.find(function (_a) {
    var columnNumbers = _a.columnNumbers;
    return columnNumbers.start - 1 <= index && index < columnNumbers.end;
  });
}

function tween(params, t) {
  if (params.fixed) return params.value;

  var _a = __read(params.interval, 2),
      start = _a[0],
      end = _a[1];

  var _b = __read(params.extremes, 2),
      from = _b[0],
      to = _b[1];

  if (t < start) return from;
  if (t > end) return to;
  var x = (t - start) / (end - start);
  var ease = params.ease || easing.linear;
  return from + ease(x) * (to - from);
}

function stagger(_a, index, count) {
  var _b = __read(_a, 2),
      start = _b[0],
      end = _b[1];

  if (count <= 1) return [start, end];
  var totalDuration = end - start;
  var stepDuration = totalDuration / Math.pow(count, 1 / 8);
  var tick = (totalDuration - stepDuration) / (count - 1);
  var stepStart = start + tick * index;
  var stepEnd = stepStart + stepDuration;
  return [stepStart, stepEnd];
}

var easing = {
  linear: function linear(t) {
    return t;
  },
  easeInQuad: function easeInQuad(t) {
    return t * t;
  },
  easeOutQuad: function easeOutQuad(t) {
    return t * (2 - t);
  },
  easeInOutCubic: function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  }
};

function getLinesWithElements(lines, verticalInterval, enterCount, exitCount) {
  // startY is the progress when we start moving vertically
  // endY is when we stop
  var _a = __read(verticalInterval, 2),
      startY = _a[0],
      endY = _a[1];

  return lines.map(function (line) {
    var lineIndex = map(line.lineNumber, function (ln) {
      return ln && ln - 1;
    });
    var enterIndex = line.enterIndex,
        exitIndex = line.exitIndex;
    var tweenY = line.move === "exit" ? {
      fixed: true,
      value: lineIndex.prev
    } : line.move === "enter" ? {
      fixed: true,
      value: lineIndex.next
    } : {
      fixed: false,
      extremes: [lineIndex.prev, lineIndex.next],
      interval: [startY, endY],
      ease: easing.easeInOutCubic
    };
    var tweenX = line.move === "exit" ? {
      fixed: false,
      extremes: [0, -1],
      ease: easing.easeInQuad,
      interval: stagger([0, startY], exitIndex, exitCount)
    } : line.move === "enter" ? {
      fixed: false,
      extremes: [1, 0],
      ease: easing.easeOutQuad,
      interval: stagger([endY, 1], enterIndex, enterCount)
    } : {
      fixed: true,
      value: 0
    };
    return _assign(_assign({}, line), {
      tweenX: tweenX,
      tweenY: tweenY
    });
  });
}

function parseAnnotations(annotations, theme) {
  var inlineCodeAnnotations = mapWithDefault(annotations, [], function (annotations) {
    return annotations.filter(isInline);
  });
  var multilineCodeAnnotations = mapWithDefault(annotations, [], function (annotations) {
    return annotations.filter(function (a) {
      return !isInline(a);
    });
  });
  return {
    inlineAnnotations: map(inlineCodeAnnotations, function (annotations) {
      return parseInlineAnnotations(annotations);
    }),
    multilineAnnotations: map(multilineCodeAnnotations, function (annotations) {
      return parseMultilineAnnotations(annotations, theme);
    })
  };
}

function isInline(annotation) {
  return hasColumns(annotation.focus);
}

function parseInlineAnnotations(annotations, theme) {
  var annotationMap = {};
  annotations.forEach(function (annotation) {
    var focusMap = parsePartToObject(annotation.focus);
    var lineNumber = +Object.keys(focusMap)[0];
    var columnNumbersList = focusMap[lineNumber];
    var lineAnnotations = annotationMap[lineNumber] || [];
    lineAnnotations.push({
      columnNumbers: columnNumbersList[0],
      data: annotation.data,
      Component: annotation.Component || defaultInlineComponent()
    });
    annotationMap[lineNumber] = lineAnnotations;
  });
  return annotationMap;
}

function defaultInlineComponent(annotation, theme) {
  return function (_a) {
    var children = _a.children;
    return React.createElement("span", {
      style: {
        outline: "red 1px solid"
      }
    }, children);
  };
}

function parseMultilineAnnotations(annotations, theme) {
  return annotations.map(function (annotation) {
    return {
      lineNumbers: parseExtremes(annotation.focus),
      data: annotation.data,
      Component: annotation.Component || defaultMultilineComponent(annotation, theme)
    };
  });
}

function defaultMultilineComponent(annotation, theme) {
  // TODO handle missing bg
  var bg = theme.colors["editor.lineHighlightBackground"] || theme.colors["editor.selectionHighlightBackground"];
  return function (_a) {
    var children = _a.children,
        style = _a.style;
    return React.createElement("div", {
      style: _assign(_assign({}, style), {
        background: bg,
        cursor: "pointer"
      }),
      onClick: function onClick(_) {
        return alert("clicked");
      }
    }, children);
  };
} // --- multiline


function annotateMultiline(lines, annotations) {
  return {
    prev: annotateMultilineSide(lines, annotations.prev, function (line) {
      return line.lineNumber.prev;
    }),
    next: annotateMultilineSide(lines, annotations.next, function (line) {
      return line.lineNumber.next;
    })
  };
}

function annotateMultilineSide(lines, ogAnnotations, getLineNumber) {
  var annotations = __spread(ogAnnotations);

  annotations.sort(function (a, b) {
    return a.lineNumbers.start - b.lineNumbers.start;
  });
  var lineIndex = 0;
  var groups = [];

  while (lineIndex < lines.length) {
    var annotation = annotations[0];
    var line = lines[lineIndex];

    if (annotation && getLineNumber(line) === annotation.lineNumbers.start) {
      // create annotation group
      var group = {
        lines: [],
        annotation: annotation
      };

      while (line && (!getLineNumber(line) || getLineNumber(line) <= annotation.lineNumbers.end)) {
        group.lines.push(line);
        line = lines[++lineIndex];
      }

      groups.push(group);
      annotations.shift();
    } else if (!annotation) {
      // create unannotated group until the end
      groups.push({
        lines: lines.slice(lineIndex)
      });
      lineIndex = lines.length;
    } else {
      // create unannotated group until next annotation
      var group = {
        lines: []
      };

      while (line && (!getLineNumber(line) || getLineNumber(line) < annotation.lineNumbers.start)) {
        group.lines.push(line);
        line = lines[++lineIndex];
      }

      groups.push(group);
    }
  }

  return groups;
} // --- inline


function annotateInline(lines, inlineAnnotations) {
  return lines.map(function (_a) {
    var groups = _a.groups,
        line = __rest(_a, ["groups"]);

    var lineNumber = line.lineNumber;
    var annotations = {
      prev: lineNumber.prev ? inlineAnnotations.prev[lineNumber.prev] || [] : [],
      next: lineNumber.next ? inlineAnnotations.next[lineNumber.next] || [] : []
    };
    return _assign(_assign({}, line), {
      annotatedGroups: annotateLineTokenGroups(groups, annotations)
    });
  });
}
/**
 * Generate a list of annotated groups tweens
 * each annotated group contains a list of token groups and maybe an annotation.
 * The two annotated groups in a tween doesn't need to have the same token groups.
 */


function annotateLineTokenGroups(tokenGroups, annotations) {
  var prevTokenGroups = __spread(tokenGroups);

  var nextTokenGroups = __spread(tokenGroups);

  var prevAnnotations = __spread(annotations.prev);

  var nextAnnotations = __spread(annotations.next);

  var annotatedGroups = [];
  var prevColumn = 1;
  var nextColumn = 1; // iterate until we consume both lists of token groups

  while (prevTokenGroups.length > 0 || nextTokenGroups.length > 0) {
    var prevAnnotation = prevAnnotations[0];
    var nextAnnotation = nextAnnotations[0];
    var isPrevAnnotationStarting = prevAnnotation && prevAnnotation.columnNumbers.start === prevColumn;
    var isNextAnnotationStarting = nextAnnotation && nextAnnotation.columnNumbers.start === nextColumn;

    if (prevColumn < nextColumn) {
      // if the prev list is behind we consume from prevTokenGroups
      if (isPrevAnnotationStarting) {
        // if there is an annotation starting at this point we consume until the annotation ends
        var end = prevAnnotation.columnNumbers.end + 1;
        annotatedGroups.push({
          prev: {
            annotation: prevAnnotation,
            groups: shiftGroups(prevTokenGroups, prevColumn, end)
          }
        });
        prevColumn = end;
        prevAnnotations.shift();
      } else {
        // if there isn't we consume until we sync with the next list or an annotation starts
        var end = Math.min(nextColumn, (prevAnnotation === null || prevAnnotation === void 0 ? void 0 : prevAnnotation.columnNumbers.start) || nextColumn);
        annotatedGroups.push({
          prev: {
            groups: shiftGroups(prevTokenGroups, prevColumn, end)
          }
        });
        prevColumn = end;
      }
    } else if (prevColumn > nextColumn) {
      // if the next list is behind we consume from nextTokenGroups
      if (isNextAnnotationStarting) {
        // if there is an annotation starting at this point we consume until the annotation ends
        var end = nextAnnotation.columnNumbers.end + 1;
        annotatedGroups.push({
          next: {
            annotation: nextAnnotation,
            groups: shiftGroups(nextTokenGroups, nextColumn, end)
          }
        });
        nextColumn = end;
        nextAnnotations.shift();
      } else {
        // if there isn't we consume until we sync with the prev list or an annotation starts
        var end = Math.min(prevColumn, (nextAnnotation === null || nextAnnotation === void 0 ? void 0 : nextAnnotation.columnNumbers.start) || prevColumn);
        annotatedGroups.push({
          next: {
            groups: shiftGroups(nextTokenGroups, nextColumn, end)
          }
        });
        nextColumn = end;
      }
    } else if (prevColumn == nextColumn) {
      // if we are at the same column in both lists we have 5 different cases
      if (isPrevAnnotationStarting && isNextAnnotationStarting && prevAnnotation.columnNumbers.end === nextAnnotation.columnNumbers.end) {
        // both annotations starts here and end at the same place, so we puth both in one tween annotated group
        var end = nextAnnotation.columnNumbers.end + 1;
        annotatedGroups.push({
          prev: {
            annotation: prevAnnotation,
            groups: shiftGroups(prevTokenGroups, prevColumn, end)
          },
          next: {
            annotation: nextAnnotation,
            groups: shiftGroups(nextTokenGroups, nextColumn, end)
          }
        });
        prevColumn = end;
        nextColumn = end;
        prevAnnotations.shift();
        nextAnnotations.shift();
      } else if (isPrevAnnotationStarting) {
        // if only the prev annotation starting at this point we consume until the annotation ends
        var end = prevAnnotation.columnNumbers.end + 1;
        annotatedGroups.push({
          prev: {
            annotation: prevAnnotation,
            groups: shiftGroups(prevTokenGroups, prevColumn, end)
          }
        });
        prevColumn = end;
        prevAnnotations.shift();
      } else if (isNextAnnotationStarting) {
        // same for the next annotation
        var end = nextAnnotation.columnNumbers.end + 1;
        annotatedGroups.push({
          next: {
            annotation: nextAnnotation,
            groups: shiftGroups(nextTokenGroups, nextColumn, end)
          }
        });
        nextColumn = end;
        nextAnnotations.shift();
      } else if (!prevAnnotation && !nextAnnotation) {
        // if there aren't any remaining annotation we add a last group
        annotatedGroups.push({
          prev: {
            groups: prevTokenGroups
          },
          next: {
            groups: nextTokenGroups
          }
        }); // this is the last iteration

        prevTokenGroups = [];
        nextTokenGroups = [];
      } else {
        // if we still have annotations left we consume until the next one
        var end = Math.min((prevAnnotation === null || prevAnnotation === void 0 ? void 0 : prevAnnotation.columnNumbers.start) || Number.MAX_VALUE, (nextAnnotation === null || nextAnnotation === void 0 ? void 0 : nextAnnotation.columnNumbers.start) || Number.MAX_VALUE);
        annotatedGroups.push({
          prev: {
            groups: shiftGroups(prevTokenGroups, prevColumn, end)
          },
          next: {
            groups: shiftGroups(nextTokenGroups, nextColumn, end)
          }
        });
        prevColumn = end;
        nextColumn = end;
      }
    }
  }

  return annotatedGroups;
}
/**
 * Remove and return some groups from the beggining of the array
 * startColumn is the column at which the array is starting
 * (because other groups has been already removed)
 * newStartColumn is the first column that should stay in the array
 */


function shiftGroups(tokenGroups, startColumn, newStartColumn) {
  var removedGroups = [];
  var currentStartColumn = startColumn;

  while (currentStartColumn < newStartColumn) {
    var currentTokenGroup = tokenGroups.shift();
    removedGroups.push(currentTokenGroup);
    var length_1 = currentTokenGroup.tokens.reduce(function (a, t) {
      return a + t.content.length;
    }, 0);
    currentStartColumn += length_1;
  }

  return removedGroups;
}

function useStepParser(input) {
  var lang = input.lang,
      theme = input.theme,
      code = input.code,
      focus = input.focus;
  return useAsyncMemo({
    isReady: isHighlighterReady(lang, theme),
    load: function load() {
      return loadHighlighter(lang, theme);
    },
    run: function run() {
      return parse(input);
    },
    placeholder: function placeholder() {
      return parse(input);
    }
  }, [code.prev, code.next, focus.prev, focus.next, lang, theme]);
}

function parse(_a) {
  var code = _a.code,
      theme = _a.theme,
      lang = _a.lang,
      focus = _a.focus,
      annotations = _a.annotations;
  var normalCode = mapWithDefault(code, "", normalize);
  var highlightedLines = map(normalCode, function (code) {
    return highlight({
      code: code,
      theme: theme,
      lang: lang
    });
  });
  var mergedCode = merge(normalCode, highlightedLines);

  var _b = parseAllAnnotations(annotations, theme),
      inlineAnnotations = _b.inlineAnnotations,
      multilineAnnotations = _b.multilineAnnotations;

  var focusedCode = splitLinesByFocus(mergedCode, withDefault(focus, null), inlineAnnotations);
  var annotatedCode = addAnnotations(focusedCode, inlineAnnotations, multilineAnnotations);
  var codeStep = addExtraStuff(annotatedCode);
  console.log({
    codeStep: codeStep
  });
  return codeStep;
} // 0 - normalize


function normalize(text) {
  // TODO replace tabs with spaces?
  return (text || "").trimEnd().concat("\n");
}

function highlight(_a) {
  var code = _a.code,
      theme = _a.theme,
      lang = _a.lang;
  var lines = highlightOrPlaceholder(code, lang, theme);
  return lines.map(function (line, i) {
    return {
      tokens: line.map(function (_a) {
        var _b = __read(_a, 2),
            content = _b[0],
            props = _b[1];

        return {
          content: content,
          props: props
        };
      })
    };
  });
}

function merge(code, highlightedLines) {
  return mergeLines(code, highlightedLines);
}

function parseAllAnnotations(annotations, theme) {
  return parseAnnotations(annotations, theme);
}

function splitLinesByFocus(mergedCode, focus, annotations) {
  return splitByFocus(mergedCode, focus, annotations);
}

function addAnnotations(_a, inlineAnnotations, annotations) {
  var lines = _a.lines,
      focusedCode = __rest(_a, ["lines"]);

  var annotatedLines = annotateInline(lines, inlineAnnotations);
  var lineGroups = annotateMultiline(annotatedLines, annotations);
  return _assign(_assign({}, focusedCode), {
    lineGroups: lineGroups,
    lineCount: {
      prev: lines.filter(function (l) {
        return l.lineNumber.prev != null;
      }).length,
      next: lines.filter(function (l) {
        return l.lineNumber.next != null;
      }).length
    }
  });
}

function addExtraStuff(codeStep) {
  var vInterval = verticalInterval(codeStep.enterCount, codeStep.exitCount);
  var newGroups = map(codeStep.lineGroups, function (groups) {
    return groups.map(function (group) {
      return _assign(_assign({}, group), {
        lines: getLinesWithElements(group.lines, vInterval, codeStep.enterCount, codeStep.exitCount)
      });
    });
  });
  return _assign(_assign({}, codeStep), {
    groups: newGroups,
    verticalInterval: vInterval
  });
}

function verticalInterval(enterCount, exitCount) {
  if (enterCount <= 0 && exitCount <= 0) return [0, 1];
  if (enterCount <= 0 && exitCount >= 1) return [0.33, 1];
  if (enterCount >= 1 && exitCount <= 0) return [0, 0.67];
  return [0.25, 0.75];
}

function SmoothContainer(_a) {
  var dimensions = _a.dimensions,
      codeStep = _a.codeStep,
      children = _a.children,
      _b = _a.minZoom,
      minZoom = _b === void 0 ? 0 : _b,
      _c = _a.maxZoom,
      maxZoom = _c === void 0 ? 1.2 : _c,
      _d = _a.center,
      center = _d === void 0 ? false : _d,
      progress = _a.progress;

  var _e = getTweenContentProps({
    codeStep: codeStep,
    dimensions: dimensions,
    minZoom: minZoom,
    maxZoom: maxZoom,
    horizontalCenter: center
  }),
      prev = _e.prev,
      next = _e.next; // all these tweens depends on annotations now (t instead of progress)


  var zoom = tweenProp(prev.zoom, next.zoom, progress);
  var dx = tweenProp(prev.dx, next.dx, progress);
  var dy = tweenProp(prev.dy, next.dy, progress, codeStep.verticalInterval);
  var focusHeight = tweenProp(prev.focusHeight, next.focusHeight, progress);
  var focusWidth = tweenProp(prev.focusWidth, prev.focusWidth, progress);
  return React.createElement(Container, {
    width: dimensions.containerWidth,
    height: dimensions.containerHeight
  }, React.createElement(Content, {
    dx: dx,
    dy: dy,
    scale: zoom,
    height: Math.max(focusHeight, dimensions.containerHeight),
    width: Math.max(focusWidth, dimensions.containerWidth)
  }, children(focusWidth)));
}

function Container(_a) {
  var width = _a.width,
      height = _a.height,
      children = _a.children;
  return React.createElement("div", {
    style: {
      width: width,
      height: height,
      position: "relative"
    }
  }, children);
}

function Content(_a) {
  var dx = _a.dx,
      dy = _a.dy,
      scale = _a.scale,
      height = _a.height,
      width = _a.width,
      children = _a.children;
  return React.createElement("div", {
    style: {
      position: "absolute",
      top: 0,
      left: 0,
      transformOrigin: "top left",
      width: width,
      height: height,
      overflow: "hidden"
    }
  }, React.createElement("div", {
    style: {
      position: "absolute",
      top: 0,
      left: 0,
      transform: "translateX(" + dx + "px) translateY(" + dy + "px) scale(" + scale + ")",
      transformOrigin: "top left",
      width: "100%"
    }
  }, children));
}

function getTweenContentProps(_a) {
  var codeStep = _a.codeStep,
      rest = __rest(_a, ["codeStep"]);

  var _b = rest.dimensions,
      lineHeight = _b.lineHeight,
      lineWidth = _b.lineWidth;
  var paramTween = {
    prev: {
      extremes: [codeStep.firstFocusedLineNumber.prev - 1, codeStep.lastFocusedLineNumber.prev - 1],
      originalContentHeight: codeStep.lineCount.prev * lineHeight,
      lineWidth: lineWidth[0]
    },
    next: {
      extremes: [codeStep.firstFocusedLineNumber.next - 1, codeStep.lastFocusedLineNumber.next - 1],
      originalContentHeight: codeStep.lineCount.next * lineHeight,
      lineWidth: lineWidth[1]
    }
  };
  return map(paramTween, function (_a) {
    var extremes = _a.extremes,
        originalContentHeight = _a.originalContentHeight,
        lineWidth = _a.lineWidth;
    return getContentProps(_assign({
      extremes: extremes,
      originalContentHeight: originalContentHeight,
      lineWidth: lineWidth
    }, rest));
  });
}

function getContentProps(_a) {
  var dimensions = _a.dimensions,
      lineWidth = _a.lineWidth,
      minZoom = _a.minZoom,
      maxZoom = _a.maxZoom,
      extremes = _a.extremes,
      originalContentHeight = _a.originalContentHeight,
      horizontalCenter = _a.horizontalCenter;
  var _b = dimensions,
      containerWidth = _b.containerWidth,
      containerHeight = _b.containerHeight,
      lineHeight = _b.lineHeight;
  var originalFocusHeight = (extremes[1] - extremes[0] + 3) * lineHeight;
  var zoom = Math.max(Math.min(containerWidth / lineWidth, containerHeight / originalFocusHeight, maxZoom), minZoom);
  var contentHeight = originalContentHeight * zoom;
  var focusStart = (extremes[0] - 1) * lineHeight * zoom;
  var focusEnd = (extremes[1] + 2) * lineHeight * zoom;
  var focusCenter = (focusEnd + focusStart) / 2;
  var focusHeight = focusEnd - focusStart;
  var dy = containerHeight > contentHeight ? (containerHeight - contentHeight) / 2 : clamp(containerHeight / 2 - focusCenter, Math.max(containerHeight - contentHeight, -focusStart // to ensure first focus line is shown when focus is bigger than container
  ), 0);
  var dx = horizontalCenter ? Math.max(containerWidth / 2 - lineWidth * zoom / 2, 0) : 0;
  return {
    zoom: zoom,
    dx: dx,
    dy: dy,
    focusHeight: focusHeight,
    focusWidth: lineWidth * zoom
  };
}

function clamp(num, min, max) {
  return num <= min ? min : num >= max ? max : num;
}

function tweenProp(start, end, progress, interval) {
  if (interval === void 0) {
    interval = [0, 1];
  }

  return tween({
    fixed: false,
    interval: interval,
    extremes: [start, end],
    ease: easing.easeInOutCubic
  }, progress);
}

function SmoothLines(props) {
  return React.createElement(SmoothContainer, _assign({}, props), function (focusWidth) {
    return React.createElement(Lines, {
      codeStep: props.codeStep,
      focusWidth: focusWidth,
      lineHeight: props.dimensions.lineHeight,
      progress: props.progress
    });
  });
}

function Lines(_a) {
  var codeStep = _a.codeStep,
      progress = _a.progress,
      focusWidth = _a.focusWidth,
      lineHeight = _a.lineHeight;
  var groups = progress < 0.5 ? codeStep.groups.prev : codeStep.groups.next;
  return React.createElement(React.Fragment, null, groups.map(function (group, i) {
    if (!group.annotation) {
      return React.createElement(LineGroup, {
        lines: group.lines,
        t: progress,
        focusWidth: focusWidth,
        lineHeight: lineHeight,
        key: i
      });
    }

    var startY = tween(group.lines[0].tweenY, progress);
    var lineCount = group.annotation.lineNumbers.end - group.annotation.lineNumbers.start + 1;
    var Component = group.annotation.Component;
    return React.createElement(Component, {
      style: {
        position: "absolute",
        height: lineCount * lineHeight,
        width: "100%",
        transform: "translateY(" + startY * lineHeight + "px)"
      },
      key: i,
      data: group.annotation.data
    }, React.createElement(LineGroup, {
      lines: group.lines,
      t: progress,
      focusWidth: focusWidth,
      lineHeight: lineHeight,
      startY: startY
    }));
  }));
}

function LineGroup(_a) {
  var lines = _a.lines,
      focusWidth = _a.focusWidth,
      lineHeight = _a.lineHeight,
      t = _a.t,
      _b = _a.startY,
      startY = _b === void 0 ? 0 : _b;
  return React.createElement(React.Fragment, null, lines.map(function (line, key) {
    var tweenX = line.tweenX,
        tweenY = line.tweenY,
        focused = line.focused;
    var dx = tween(tweenX, t);
    var dy = tween(tweenY, t);
    var opacity = getOpacity(focused, t, dx);
    return React.createElement(LineContainer, {
      key: key,
      dx: 16 + dx * focusWidth,
      dy: (dy - startY) * lineHeight,
      width: focusWidth,
      opacity: opacity
    }, React.createElement(LineContent, {
      line: line,
      progress: t,
      dx: dx
    }));
  }));
}

function LineContent(_a) {
  var line = _a.line,
      progress = _a.progress,
      dx = _a.dx;
  return React.createElement("div", {
    style: {
      display: "inline-block",
      width: "100%"
    }
  }, line.annotatedGroups.map(function (annotatedGroup, i) {
    return React.createElement(AnnotatedTokens, {
      annotatedGroup: annotatedGroup,
      progress: progress,
      dx: dx,
      key: i
    });
  }), React.createElement("br", null));
}

function AnnotatedTokens(_a) {
  var _b, _c;

  var annotatedGroup = _a.annotatedGroup,
      progress = _a.progress,
      dx = _a.dx;
  var annotated = progress < 0.5 ? annotatedGroup.prev : annotatedGroup.next;
  var tokenGroups = (annotated === null || annotated === void 0 ? void 0 : annotated.groups) || [];
  var Component = (_b = annotated === null || annotated === void 0 ? void 0 : annotated.annotation) === null || _b === void 0 ? void 0 : _b.Component;
  var children = tokenGroups.map(function (group, i) {
    var opacity = getOpacity(group.focused, progress, dx);
    return React.createElement("span", {
      style: {
        opacity: opacity
      },
      key: i + 1
    }, group.element);
  });
  return Component ? React.createElement(Component, {
    children: children,
    data: (_c = annotated === null || annotated === void 0 ? void 0 : annotated.annotation) === null || _c === void 0 ? void 0 : _c.data
  }) : React.createElement(React.Fragment, null, children);
}

function LineContainer(_a) {
  var children = _a.children,
      dx = _a.dx,
      dy = _a.dy,
      opacity = _a.opacity,
      width = _a.width;
  return React.createElement("div", {
    style: {
      position: "absolute",
      top: 0,
      left: 0,
      transform: "translate(" + dx + "px, " + dy + "px)",
      width: width,
      display: opacity <= 0 ? "none" : undefined
    }
  }, children);
}

var OFF_OPACITY = 0.33;

function getOpacity(focused, progress, dx) {
  return tween({
    fixed: false,
    extremes: [focused.prev ? 0.99 : OFF_OPACITY, focused.next ? 0.99 : OFF_OPACITY],
    interval: [0, 1]
  }, progress) - Math.abs(dx) * 1;
}

var DEFAULT_MIN_COLUMNS = 40;

function Code(props) {
  var code = props.code,
      focus = props.focus,
      parentHeight = props.parentHeight,
      htmlProps = props.htmlProps,
      _a = props.theme,
      theme = _a === void 0 ? DEFAULT_THEME : _a,
      language = props.language,
      annotations = props.annotations,
      _b = props.minColumns,
      minColumns = _b === void 0 ? DEFAULT_MIN_COLUMNS : _b;

  var _c = useDimensions(code, focus, minColumns, [parentHeight]),
      element = _c.element,
      dimensions = _c.dimensions;

  var stepInfo = useStepParser({
    code: code,
    theme: theme,
    lang: language,
    focus: focus,
    annotations: annotations
  });
  return !dimensions ? React.createElement(BeforeDimensions, {
    element: element,
    htmlProps: htmlProps
  }) : React.createElement(AfterDimensions, _assign({
    dimensions: dimensions,
    stepInfo: stepInfo
  }, props));
}

function BeforeDimensions(_a) {
  var element = _a.element,
      htmlProps = _a.htmlProps;
  return React.createElement(Wrapper, {
    htmlProps: htmlProps,
    // avoid scrollbars when measuring
    style: {
      overflow: "hidden",
      opacity: 0
    }
  }, element);
}

function AfterDimensions(_a) {
  var progress = _a.progress,
      _b = _a.minZoom,
      minZoom = _b === void 0 ? 0.5 : _b,
      _c = _a.maxZoom,
      maxZoom = _c === void 0 ? 1.5 : _c,
      _d = _a.horizontalCenter,
      horizontalCenter = _d === void 0 ? false : _d,
      htmlProps = _a.htmlProps,
      _e = _a.theme,
      theme = _e === void 0 ? DEFAULT_THEME : _e,
      dimensions = _a.dimensions,
      stepInfo = _a.stepInfo;

  var _f = getThemeDefaultColors(theme),
      bg = _f.bg,
      fg = _f.fg;

  return React.createElement(Wrapper, {
    htmlProps: htmlProps,
    style: {
      opacity: 1,
      backgroundColor: bg,
      color: fg
    }
  }, React.createElement(SmoothLines, {
    codeStep: stepInfo,
    progress: progress,
    dimensions: dimensions,
    // TODO move to dimensions?
    minZoom: minZoom,
    maxZoom: maxZoom,
    center: horizontalCenter
  }));
}

function Wrapper(_a) {
  var htmlProps = _a.htmlProps,
      style = _a.style,
      children = _a.children;
  return React.createElement("pre", _assign({}, htmlProps, {
    style: _assign(_assign({
      margin: 0
    }, style), htmlProps === null || htmlProps === void 0 ? void 0 : htmlProps.style)
  }), React.createElement("code", null, children));
} // import onigasm from "arraybuffer-loader!shiki/dist/onigasm.wasm"
// import theme from "shiki/themes/dark-plus.json"
// setCDN("https://unpkg.com/shiki/")
// const FONT_STYLE_TO_CSS = {
//   [FontStyle.NotSet]: {},
//   [FontStyle.None]: {},
//   [FontStyle.Italic]: { fontStyle: "italic" },
//   [FontStyle.Bold]: { fontWeight: "bold" },
//   [FontStyle.Underline]: { textDecoration: "underline" },
// }
// // console.log({ theme })
// const DEFAULT_THEME = "dark-plus"
// const highlighterPromise = getHighlighter({
//   theme: DEFAULT_THEME,
//   langs: ["js", "ts"],
// })
// type CodeTweenProps = {
//   code: string
//   lang: string
//   theme?: IShikiTheme
//   htmlProps: React.DetailedHTMLProps<
//     React.HTMLAttributes<HTMLPreElement>,
//     HTMLPreElement
//   >
// }


function CodeTween() {
  return null;
}

export { Code, CodeTween };